import * as Yup from 'yup';
import { MTA_ADDRESS_CHANGE_ERRORS, TAXI_ERRORS } from '@acorn-portal/shared/src/utils/constants/ErrorMessages';
import { ICreateNewRenewalVersionResponse } from '@acorn-portal/shared/src/store/renewal.slice';
import { isUsedForBusiness } from '@acorn-portal/shared/src/utils';
import { IMidTermAdjustmentState } from '@acorn-portal/shared/src/store/midTermAdjustment.slice';
import { FullPolicy } from '@acorn-portal/shared/src/services/api';
import { Product } from '../../services/interface/Shared';

const ChangeOfAddressSchema = (
	state: ICreateNewRenewalVersionResponse | IMidTermAdjustmentState,
	fullPolicy: FullPolicy,
) =>
	Yup.object().shape({
		isHomeOwner: Yup.string().required(MTA_ADDRESS_CHANGE_ERRORS.homeOwnerRequired),
		annualMileage: Yup.number().when([], {
			is: () =>
				fullPolicy.product === Product.TAXI ||
				(fullPolicy.product === Product.TELEMATICS && fullPolicy.productCode === 'MyPolicy'),
			then: (schema) => schema.notRequired(),
			otherwise: (schema) =>
				schema
					.min(0, MTA_ADDRESS_CHANGE_ERRORS.annualMileageGreaterThanZero)
					.required(MTA_ADDRESS_CHANGE_ERRORS.annualMileageRequired),
		}),

		licencingAuthority: Yup.string().when([], {
			is: () => fullPolicy.product === Product.TAXI,
			then: (schema) => schema.required(TAXI_ERRORS.licensingAuthority),
			otherwise: (schema) => schema.notRequired(),
		}),

		operatingArea: Yup.string().when([], {
			is: () => fullPolicy.product === Product.TAXI,
			then: (schema) => schema.required(TAXI_ERRORS.operatingArea),
			otherwise: (schema) => schema.notRequired(),
		}),

		businessMileage: Yup.mixed().when('vehicleUse', {
			is: () => isUsedForBusiness(state.vehicleDetails.vehicleUse),
			then: () =>
				Yup.number()
					.min(1, MTA_ADDRESS_CHANGE_ERRORS.businessMileageGreaterThanZero)
					.required(MTA_ADDRESS_CHANGE_ERRORS.businessMileageRequired),
			otherwise: (schema) => schema.notRequired(),
		}),

		keptOvernight: Yup.string()
			.test('keptOvernight-more-validation', 'please verify where the vehicle is kept overnight', function (value) {
				return !!value && value !== 'More';
			})
			.required(MTA_ADDRESS_CHANGE_ERRORS.keptOvernight),

		overnightAddress: Yup.mixed().when('overnightAddressIsAway', {
			is: 'yes',
			then: () =>
				Yup.object().shape({
					line1: Yup.string().required('Please enter your address'),
				}),
			otherwise: (schema) => schema.notRequired(),
		}),

		address: Yup.object().shape({
			line1: Yup.string().required('Please enter your address'),
		}),

		overnightAddressIsAway: Yup.string().required(MTA_ADDRESS_CHANGE_ERRORS.overnightAddressIsAwayRequired),
	});

export default ChangeOfAddressSchema;
